import { CartProcessingRedirect } from 'store/shoppingCart/types';

type RecipientPaymentStatus = {
  stripe_status?: string;
  de_status?: string | null;
  is_stripe_authorized?: boolean;
};

export const canAcceptDonationsThrough = (
  recipient: RecipientPaymentStatus,
  processingRedirect: CartProcessingRedirect | undefined
) => {
  if (processingRedirect === CartProcessingRedirect.DE_OATH) {
    return recipient.de_status === 'ACTIVE';
  }
  if (processingRedirect === CartProcessingRedirect.STRIPE) {
    return recipient.stripe_status === 'ACTIVE' && !!recipient.is_stripe_authorized;
  }
  return false;
};
